import { Component, ElementRef, Input, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { isObservable, Observable, Subscription } from 'rxjs';


export interface SplitButtonElement {
	title: string,
	shortTitle?: string,
	icon?: string,
	iconOnly?: boolean,
	iconType?: 'feather' | 'nzicon' | undefined, // 'feather' ist default
	hasDivider?: boolean,
	type: 'primary' | 'default' | 'danger',
	callback?: () => unknown,
	disabled?: boolean,
	buttonType?: 'button' | 'submit' | 'reset',
	attrForm?: string,
	titleParams?: unknown,
	observableTitleParams?: { [key: string]: Observable<any> },
}

@Component({
	selector: 'app-splitbutton',
	templateUrl: './splitbutton.component.html',
	styleUrls: ['./splitbutton.component.scss'],
})

export class SplitbuttonComponent implements OnDestroy {
	@Input() set elements(btnElements: SplitButtonElement[]) {
		this.elementsOrig = btnElements || [];
		this.updateSplitButtonList();
	}
	@Input() size: 'default' | 'small' | 'large' = 'default';
	@Input() noIcon = false;
	@Input() iconRight = false;
	@Input() block = false;
	@Input() specialType = '';
	@Input() isSpin = false;
	@Input() set burgerMenu(isBurgerMenu: boolean) {
		this.isBurgerMenu = isBurgerMenu;
		this.updateSplitButtonList();
	}
	@Input() disabled = false;

	@ViewChild('splitButton', {read: ViewContainerRef})
	set _splitButtonElement(splitButton: ViewContainerRef) {
		this.splitButtonElement = splitButton?.element;
	}

	isPopoverVisible = false;
	isBurgerMenu = false;
	firstActiveElement: SplitButtonElement;
	listElements: SplitButtonElement[] = [];
	splitButtonElement: ElementRef;
	private subscription = new Subscription();
	private elementsOrig: SplitButtonElement[] = [];

	constructor() {}

	public elementCallback(element: SplitButtonElement): unknown {
		this.isPopoverVisible = false;
		if (element.callback) {
			return element.callback();
		}
	}

	private updateSplitButtonList(): void {
		this.subscription.unsubscribe();
		this.subscription = new Subscription();

		const btnElements = [...this.elementsOrig];
		if (!btnElements.length) {
			this.listElements = [];
			this.firstActiveElement = null;

			return;
		}

		for (const element of btnElements) {
			for (const titleParam in element.observableTitleParams) {
				const observableParam = element.observableTitleParams[titleParam];
				if (isObservable(observableParam)) {
					element.titleParams = element.titleParams || {};
					this.subscription.add(observableParam.subscribe(resolved => element.titleParams[titleParam] = resolved));
				}
			}
		}

		if (!this.isBurgerMenu) {
			this.firstActiveElement = btnElements.find(element => !element.disabled) || btnElements[0];
		} else {
			this.firstActiveElement = null;
		}

		this.listElements = btnElements;
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
